import { render } from "./Manifest.vue?vue&type=template&id=3de93815&scoped=true"
import script from "./Manifest.vue?vue&type=script&lang=js"
export * from "./Manifest.vue?vue&type=script&lang=js"

import "./Manifest.vue?vue&type=style&index=0&id=3de93815&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de93815"]])

export default __exports__